module.exports = __webpack_public_path__ + "static/media/sh_1.aaef05f7.ogg";